import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import './StatusPill.module.scss'

// Variant → the status-pill token class. Mirrors the in-app `StatusBadge` so the export
// matches the interface: soft tinted background, thin border, dark-tone label (never the
// heavy bright pill with near-black text).
const VARIANT_CLASS = {
  success: 'Uic-ComplianceAuditStatusPill-success',
  warning: 'Uic-ComplianceAuditStatusPill-warning',
  danger: 'Uic-ComplianceAuditStatusPill-danger',
  primary: 'Uic-ComplianceAuditStatusPill-primary',
  secondary: 'Uic-ComplianceAuditStatusPill-secondary',
}

const propTypes = {
  /** Status-pill variant (from `getComplianceAuditStatusBadgeVariant`). */
  variant: PropTypes.oneOf(['success', 'warning', 'danger', 'primary', 'secondary']),
  /** Visible status label, e.g. "Partial". */
  label: PropTypes.node,
  /**
   * Optional trailing detail shown after a divider — e.g. the partial-compliance ratio.
   * Mirrors the interface StatusBadge, which appends the % for partial checks.
   */
  detail: PropTypes.node,
  /** Let the label wrap inside narrow table cells instead of overflowing. */
  wrap: PropTypes.bool,
  /** Class to extend or override default styles. */
  className: PropTypes.string,
}

/**
 * StatusPill — the Compliance Audit export's status chip. A presentational match for the
 * in-app `StatusBadge`, using the shared `--aug-status-pill-*` tokens so export and
 * interface read identically. Tokenized for light + dark.
 */
function StatusPill({ variant = 'secondary', label = null, detail = null, wrap = false, className = '' }) {
  return (
    <span
      className={clsx(
        'Uic-ComplianceAuditStatusPill-root',
        VARIANT_CLASS[variant],
        wrap && 'Uic-ComplianceAuditStatusPill-wrap',
        className,
      )}
    >
      <span className="Uic-ComplianceAuditStatusPill-label">{label}</span>
      {detail != null && detail !== '' && <span className="Uic-ComplianceAuditStatusPill-detail">{detail}</span>}
    </span>
  )
}

StatusPill.propTypes = propTypes

export default StatusPill
